export interface FooterButtonModel {
  text?: string;
  icon?: string;
  hidden?: boolean;
}
